<div
  class="inline-flex items-center border border-border-strong rounded-lg overflow-hidden h-11 bg-bg"
>
  <button
    type="button"
    (click)="decrementQuantity()"
    class="flex items-center justify-center w-8 sm:w-10 h-full text-fg-subtle hover:text-fg hover:bg-bg-alt transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
    [disabled]="currentQuantity === MIN_QUANTITY"
    aria-label="Disminuir cantidad"
  >
    <ml-icon name="minus" class="w-3 h-3 sm:w-3.5 sm:h-3.5" />
  </button>
  <span
    class="w-8 sm:w-10 border-x border-border text-center text-sm font-medium text-fg select-none leading-none flex items-center justify-center h-full"
  >
    {{ currentQuantity }}
  </span>
  <button
    type="button"
    (click)="incrementQuantity()"
    class="flex items-center justify-center w-8 sm:w-10 h-full text-fg-subtle hover:text-fg hover:bg-bg-alt transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
    [disabled]="currentQuantity === MAX_QUANTITY"
    aria-label="Aumentar cantidad"
  >
    <ml-icon name="plus" class="w-3 h-3 sm:w-3.5 sm:h-3.5" />
  </button>
</div>
